function currencyFormSubmit(e) {
	e.target.form.submit()
}

function openTab(e, t) {
	var n, o, i;
	for (n = 0, o = document.getElementsByClassName("tabcontent-cus"); n < o.length; n++) o[n].style.display = "none";
	for (n = 0, i = document.getElementsByClassName("tablinks-cus"); n < i.length; n++) i[n].className = i[n].className.replace(" active", "");
	document.getElementById(t).style.display = "block", e.currentTarget.className += " active"
}


 $(document).on("click",".title-footer",function(){
   if (1099 >= $(window).width()){
      $(this).parent().toggleClass("active").find(".footer-toggle").slideToggle("slow")
   }
})

function ToggleIcon() {
    if ($(window).width() >= 1099) {
        $(".footer_inner .footer-cms .title-footer").parent().find(".footer-toggle").removeAttr("style");
        $(".footer_inner .footer-cms .title-footer").removeClass("toggle-active");
    }
}

$( window ).resize(function() {
	ToggleIcon();
});
  
function popup_product() {
	$(".button_product .button_point").on("click", function() {
		var e = $(this).parent(),
			t = e.position(),
			n = $(this).siblings();
		1024 > $(window).width() && n.css({
			top: 100 - t.top,
			left: 30 - t.left
		}), e.addClass("is-open")
	}), $(".custom-product-card .close").on("click", function() {
		$(this).parents(".button_product").removeClass("is-open")
	}), $(document).on("click", function(e) {
		0 === $(e.target).closest(".custom-product-card").length && 0 === $(e.target).closest(".button_product").length && $(".button_product").removeClass("is-open")
	})
}
window.theme = window.theme || {}, theme.Sections = function e() {
	this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:section:reorder", this._onReorder.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
	_createInstance: function e(t, n) {
		var o = $(t),
			i = o.attr("data-section-id"),
			s = o.attr("data-section-type");
		if (n = n || this.constructors[s], !_.isUndefined(n)) {
			var c = _.assignIn(new n(t), {
				id: i,
				type: s,
				container: t
			});
			this.instances.push(c)
		}
	},
	_onSectionLoad: function e(t) {
		var n = $("[data-section-id]", t.target)[0];
		n && this._createInstance(n)
	},
	_onSectionUnload: function e(t) {
		this.instances = _.filter(this.instances, function(e) {
			var n = e.id === t.originalEvent.detail.sectionId;
			return n && _.isFunction(e.onUnload) && e.onUnload(t), !n
		})
	},
	_onSelect: function e(t) {
		var n = _.find(this.instances, function(e) {
			return e.id === t.originalEvent.detail.sectionId
		});
		!_.isUndefined(n) && _.isFunction(n.onSelect) && n.onSelect(t)
	},
	_onDeselect: function e(t) {
		var n = _.find(this.instances, function(e) {
			return e.id === t.originalEvent.detail.sectionId
		});
		!_.isUndefined(n) && _.isFunction(n.onDeselect) && n.onDeselect(t)
	},
	_onReorder: function e(t) {
		var n = _.find(this.instances, function(e) {
			return e.id === t.originalEvent.detail.sectionId
		});
		!_.isUndefined(n) && _.isFunction(n.onReorder) && n.onReorder(t)
	},
	_onBlockSelect: function e(t) {
		var n = _.find(this.instances, function(e) {
			return e.id === t.originalEvent.detail.sectionId
		});
		!_.isUndefined(n) && _.isFunction(n.onBlockSelect) && n.onBlockSelect(t)
	},
	_onBlockDeselect: function e(t) {
		var n = _.find(this.instances, function(e) {
			return e.id === t.originalEvent.detail.sectionId
		});
		!_.isUndefined(n) && _.isFunction(n.onBlockDeselect) && n.onBlockDeselect(t)
	},
	register: function e(t, n) {
		this.constructors[t] = n, $("[data-section-type=" + t + "]").each((function(e, t) {
			this._createInstance(t, n)
		}).bind(this))
	}
}), theme.HomeSlideshow = function e(t) {
	var n = this.$container = $(t),
		o = this.sectionId = n.attr("data-section-id");
	this.sliderActive = $("#home-slider-" + o).length;
	var i = n.attr("data-animation-speed");
	if ("true" == n.attr("data-autoPlay")) var s = i > 0 && {
		delay: +i
	};
	else s = "false";
	if ($("#home-slider-" + o + " .swiper-slide").length > 1) var c = !0,
		r = !0;
	else var c = !1,
		r = !1;
	this.lgSlider = new Swiper("#home-slider-" + o, {
		navigation: {
			nextEl: "#swiper-button-next-" + o,
			prevEl: "#swiper-button-prev-" + o
		},
		direction: "horizontal",
		speed: 1200,
		loop: c,
		simulateTouch: r,
		pagination: {
			el: "#swiper-pagination-" + o,
			clickable: !0
		},
		autoplay: s,
		autoHeight: !0
	})
}, theme.HomeSlideshow.prototype = _.assignIn({}, theme.HomeSlideshow.prototype, {
	onBlockSelect: function e(t) {
		this.sectionId;
		var n = $(t.target).data("index"),
			o = this.lgSlider;
		this.lgSliderMobile, o.slideTo(n, 1500, !1), o.autoplay.stop()
	},
	onBlockDeselect: function e() {
		this.sectionId;
		var t = this.lgSlider;
		this.lgSliderMobile, t.autoplay.start()
	}
}), $(document).ready(function() {
	new theme.Sections().register("slideshow-section", theme.HomeSlideshow), $(document).on("shopify:section:select", function(e) {
		var t = $(e.target),
			n = $("#shopify-section-handle-" + e.originalEvent.detail.sectionId),
			o = n.length ? n.attr("data-bg-type") : null;
		o && t.addClass(o)
	})
}), document.querySelectorAll(".shopify-currency-form select").forEach(function(e) {
	e.addEventListener("change", currencyFormSubmit)
}), null !== document.querySelector("#tab-cus-active") && document.getElementById("tab-cus-active").click(), $(document).ready(function() {
	let e = localStorage.getItem("gridSize");

	function t(e) {
		localStorage.setItem("gridSize", e), $(".grid-setup-" + e).addClass("active");
		let t = $(".productGridBtn").length;
		for (let n = 1; n <= t; n++) $(".grid-collection-product .product-grid").removeClass(`grid--${n}-col-desktop active`);
		$(".grid-collection-product .product-grid").addClass(`grid--${e}-col-desktop active`)
      for (let n = 1; n <= t; n++) $(".grid-collection-product .product-grid").removeClass(`grid--${n}-col-tablet-down active`);
		$(".grid-collection-product .product-grid").addClass(`grid--${e}-col-tablet-down active`)
	}
	e && t(e), $(document).on("click", ".productGridBtn", function() {
		let e = $(this).attr("data-count");
		$(".productGridBtn").removeClass("active"), t(e)
	})
}), $(document).ready(function() {
	$(document).on("click", ".popup-close", function() {
		$(".widget-sticky-pop").toggleClass("active")
	})
}), $(document).on("click", ".btn-save", function() {
	$("#Details-CartDrawer").removeAttr("open")
}),  $(document).ready(function() {
	$(".quickview-btn").click(function() {
		$("body").css("overflow", "hidden")
	}), $(document).on("click", "#ModalClose-quick-view", function() {
		$("body").css("overflow", "auto")
	})
}), $(document).ready(function() {
	ToggleIcon(), $(".cart-notification__close").click(function() {
		$("body").css("overflow", "hidden")
	}), $(document).on("click", ".cart-notification-wrapper", function() {
		$("body").css("overflow", "auto")
	})
}), $(".button_product .button_point").on("click", function() {
	var e = $(this).parent(),
		t = e.position(),
		n = $(this).siblings();
	1024 > $(window).width() && n.css({
		top: 100 - t.top,
		left: 30 - t.left
	}), e.addClass("is-open")
}), $(".custom-product-card .close").on("click", function() {
	$(this).parents(".button_product").removeClass("is-open")
}), $(document).on("click", function(e) {
	0 === $(e.target).closest(".custom-product-card").length && 0 === $(e.target).closest(".button_product").length && $(".button_product").removeClass("is-open")
}), jQuery(document).ready(function() {
	var e, t = !1,
		n = $(".close_popup");

	function o(e, t, n) {
		var o = new Date;
		o.setTime(o.getTime() + 3e5 * n);
		var i = "expires=" + o.toGMTString();
		document.cookie = e + "=" + t + "; " + i
	}
	"" !== (e = function e(t) {
		for (var n = t + "=", o = document.cookie.split(";"), i = 0; i < o.length; i++) {
			var s = o[i].trim();
			if (0 === s.indexOf(n)) return s.substring(n.length, s.length)
		}
		return ""
	}("dt_gdpr_name")) ? t = !0: "" !== e && null !== e && o("cookie_value", "cookie_value", 365), !0 === t && n.hide(), $(".accept-cookie2").click(function() {
		o("dt_gdpr_name", "cookie_value", 365), n.hide()
	}), $(".close-icon").click(function() {
		o("dt_gdpr_name", "", -1), n.hide()
	})
});

                  
  document.addEventListener('readystatechange', event => {

      if (event.target.readyState === "complete") {
        
        var clockdiv = document.getElementsByClassName("clockdiv");
        var countDownDate = new Array();
        for (var i = 0; i < clockdiv.length; i++) {



          const attrDate = new Date($(clockdiv[i]).attr("data-date"));
          const currentDateTime = new Date();
          if(currentDateTime > attrDate){
              $(clockdiv[i]).hide()
          }


          countDownDate[i] = new Array();
          countDownDate[i]['el'] = clockdiv[i];
          countDownDate[i]['time'] = new Date(clockdiv[i].getAttribute('data-date')).getTime();
          countDownDate[i]['days'] = 0;
          countDownDate[i]['hours'] = 0;
          countDownDate[i]['seconds'] = 0;
          countDownDate[i]['minutes'] = 0;
          }
        
        var countdownfunction = setInterval(function() {
    for (var i = 0; i < countDownDate.length; i++) {
        var now = new Date().getTime();


          const attrDate = new Date($(clockdiv[i]).attr("data-date"));
          const currentDateTime = new Date();
          if(currentDateTime > attrDate){
              $(clockdiv[i]).hide()
          }




        var distance = countDownDate[i]['time'] - now;
         countDownDate[i]['days'] = Math.floor(distance / (1000 * 60 * 60 * 24));
         countDownDate[i]['hours'] = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
         countDownDate[i]['minutes'] = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
         countDownDate[i]['seconds'] = Math.floor((distance % (1000 * 60)) / 1000);
        
          if (distance < 0) {
            countDownDate[i]['el'].querySelector('.days').innerHTML = 0;
            countDownDate[i]['el'].querySelector('.hours').innerHTML = 0;
            countDownDate[i]['el'].querySelector('.minutes').innerHTML = 0;
            countDownDate[i]['el'].querySelector('.seconds').innerHTML = 0;
          }
          else{
          countDownDate[i]['el'].querySelector('.days').innerHTML = countDownDate[i]['days'];
          countDownDate[i]['el'].querySelector('.hours').innerHTML = countDownDate[i]['hours'];
          countDownDate[i]['el'].querySelector('.minutes').innerHTML = countDownDate[i]['minutes'];
          countDownDate[i]['el'].querySelector('.seconds').innerHTML = countDownDate[i]['seconds'];
        }
    
    }
  }, 1000);
  }
});

 $('.menu-drawer-remove-button button').on("click",function(){
   $('body').removeClass('overflow-hidden-tablet');
});

  var usedHideScroll = 0;
  
    var scrollValue = 0;

var vBtn; 
var vForm; 

    function hideScroll(){
      scrollValue = $(document).scrollTop();
      $('html, body').addClass('no-overflow')
        //.css('top', -scrollValue).css('position', 'fixed');
      
      console.log('function hideScroll()');
      
      usedHideScroll = 1;
    }
    
       function showScroll(){
         $('html, body').removeClass('no-overflow')
           //.css('position', 'inherit').css('top', 0);
         
         $('html, body').animate({
        scrollTop: scrollValue},
        0);
         console.log('function showScroll()');
         
         usedHideScroll = 0;
      }
  
  function toggleScroll(){
    if($('html').hasClass('no-overflow')){
      showScroll();
    console.log('toggleScroll(); showing scroll');
    }
    else{
      hideScroll();
    console.log('toggleScroll(); hiding scroll');
    }
  }

  function pickWeightLimits(){
    var newVariant = vForm.find('[name="id"]').val();
    console.log('variant changed. New variant: ' + newVariant);

    if(newVariant != null){
      if(vForm.find('[name="id"] option').length > 0){
        var optionObj = vForm.find('[name="id"] option[value="'+ newVariant +'"]');
      }
      else{
        var optionObj = vForm.find('[name="id"]');
      }

      var min = optionObj.data('min-weight');
      var max = optionObj.data('max-weight');

      console.log('min: ' + min + '; max: ' + max);

      $('.weight-field').attr('min', min)
        
        if(max != ''){
          $('.weight-field').attr('max', max);
        }
      else{
        $('.weight-field').removeAttr('max');
      }
    }
  }

  function validateWeightNum(){
    console.log('weight value changed. val: ' + $('.modal__input.weight-field').val() + '; min: ' + $('.modal__input.weight-field').attr('min') + '; max: ' + $('.modal__input.weight-field').attr('max'));
      if(Number($('.modal__input.weight-field').val()) < Number($('.modal__input.weight-field').attr('min')) || Number($('.modal__input.weight-field').val()) > Number($('.modal__input.weight-field').attr('max'))){
        $('.modal__input.weight-field').parents('.form-block').find('.error-text').slideDown(300);
        console.log('Should slide down');
      }
      else{
        $('.modal__input.weight-field').parents('.form-block').find('.error-text').slideUp(300); 
        console.log('Should slide up');
      }
  }

function validateAge(){
  var parent = $('.years-field').parents('.age-holder');
  var years = Number($('.years-field').val());
  var months = Number($('.months-field').val());
  var minMonths = Number($('.months-field').data('min'));
console.log('years: ' + years + '; months: ' + months);
  if(years == 0){

    if(months < minMonths){
      parent.find('.error-text').slideDown(300);
      $('.verificationModalSubmit').addClass('disabled');
    }
    else{
      parent.find('.error-text').slideUp(300);
      $('.verificationModalSubmit').removeClass('disabled');
    }
  }
    else{
      parent.find('.error-text').slideUp(300);
      $('.verificationModalSubmit').removeClass('disabled');
    }
}

function pickPetType(){
  var newVariant = vForm.find('[name="id"]').val();
    console.log('pickPetType variant changed. New variant: ' + newVariant);

    if(newVariant != null){
      if(vForm.find('[name="id"] option').length > 0){
        var optionObj = vForm.find('[name="id"] option[value="'+ newVariant +'"]');
      }
      else{
        var optionObj = vForm.find('[name="id"]');
      }
      var newPetTypes = optionObj.data('pet-type');

      $('#pet-verification-popup .form-option-holder.pet-type-field input[type="radio"]').each(function(){

        var tag = $(this).data('type-tag');

        if(newPetTypes.indexOf(tag) > -1){
          $(this).attr('disabled', false);
        }
        else{
          $(this).attr('disabled', true);
        }
        
      })
    }
  
}

function checkCartPopup(){

  if($('.cart-item[data-has-it="1"]').length > 0){
    console.log('should show popup');
    $('.cart-finish').addClass('showPopup');
  }
  else{
    $('.cart-finish').removeClass('showPopup');
  }
  
}

function cartPopupFunctions(){


//console.log('here')
  checkCartPopup();

  $(document).on("DOMSubtreeModified", 'form[action="/cart"]:not(.customForm)', function(){ 
    console.log('cart changed. Checking popup');
   checkCartPopup();
  })

  $(document).on('click','.cart-submit-popup',function(e){
    e.preventDefault();
    
    console.log('showing popup now');

     $('html').addClass('modal-open');
      hideScroll();

    var prescriptionHtml = '';
    var prescriptionIds = '';
    
    $('.cart-items .cart-item[data-has-it="1"]').each(function(){

      if(prescriptionIds.indexOf($(this).data('id')) == -1){
        prescriptionIds+= $(this).data('id');
      prescriptionHtml = prescriptionHtml + $(this).prop('outerHTML');
    }
    });
console.log(prescriptionHtml);
    $('.prescription-items-holder').html('');
    $('.prescription-items-holder').html(prescriptionHtml);

    
    $('#prescription-popup').fadeIn(300);
    
  })
}

$(document).ready(function(){

  cartPopupFunctions();

  if($('#pet-verification-popup').length > 0){
    
    $(document).on('click', '.verificationOpen', function(e){
      e.preventDefault();
      
      vBtn = $(this);
      vForm = vBtn.parents('form');

      console.log('form class:', vForm.attr('class'));
      
      pickWeightLimits();
      if($('.modal__input.weight-field').val().length > 0){
      validateWeightNum();
      }
      pickPetType();
      
      $('html').addClass('modal-open');
      hideScroll();
      console.log('should open popup');
    $('#pet-verification-popup').fadeIn(300);

      var variantId = $(this).parents('form').find('[name="id"]').val();
      
$('.verification-variant-id').val(variantId);
  })

 $('.modal__close').click(function(){
   showScroll();
 $(this).parents('.modal__overlay').fadeOut(300);
      $('html').removeClass('modal-open');
    })

    $(".modal__overlay").click(function(e){
      
     if(e.target !== e.currentTarget) return;
      showScroll();
      $(this).fadeOut(300);
      $('html').removeClass('modal-open');
});
    
//pickWeightLimits();
    
    $('select[name="id"]').change(function(){
      
      vBtn = $(this);
      vForm = vBtn.parents('form');
      
      pickWeightLimits();
      if($('.modal__input.weight-field').val().length > 0){
      validateWeightNum();
      }
      pickPetType();
    })

    $('.modal__input.weight-field').change(function(){
      validateWeightNum();
    })
  }

$(document).on('input','.age-field', function(){
    validateAge();
  })

$('.verificationModalSubmit').click(function(){
  $('.required-holder').each(function(){

    console.log('found required');

    var parent = $(this);

    var inputs = parent.find('input:not([type="hidden"])');
    if(inputs.length == 1){
if(!inputs.val()){
  console.log('input invalid');
parent.addClass('error');
}
      else{
parent.removeClass('error');
  console.log('input valid');
}
    }
    else{
      console.log(inputs.first().attr('type'), inputs.first().attr('name'));
      if(inputs.first().attr('type') == 'checkbox'){
        console.log('checkboxes: ', parent.find('input[required]').length, parent.find('input:checked').length);
        if(parent.find('input[required]').length == parent.find('input:checked').length){
          parent.removeClass('error');
  console.log('input is valid');
        }
        else{
          parent.addClass('error');
  console.log('input is invalid');
        }
      }
      else if(inputs.first().attr('type') == 'radio'){
        console.log('radioboxes: ',parent.find('input[required]:checked').length);
        if(parent.find('input[required]:checked').length == 1){
           parent.removeClass('error');
  console.log('input valid');
        }
        else{
          parent.addClass('error');
  console.log('input invalid');
        }
}
    }
  })
})
  
  $(document).on('submit', '.pet-verification-form', function(e){
    e.preventDefault();
    
  //  if($('.pet-type-field input:checked').length == 1){
    
  //  console.log('form is stopped from submitting');

    $('.modal__form-elements [required]').each(function(){
      
    })

    
     var form = $(this);
    var actionUrl = form.attr('action');
    
    $.ajax({
        type: "POST",
        url: actionUrl,
        data: form.serialize(), // serializes the form's elements.
        success: function(data)
        {
          window.location.href = '/cart';
        }
    });
   // }
  })

$(document).on('change','.pet-type-field input',function(){
  $('.pet-type-backup').val($(this).val());
})

  $('input[name="id"]').each(function(){
  var idField = $(this);
  var id = idField.val();
  var selectField = $(this).siblings('select');

  idField.attr('data-max-weight',selectField.find('option[value="'+id+'"]').attr('data-max-weight'));
  idField.attr('data-min-weight',selectField.find('option[value="'+id+'"]').attr('data-min-weight'));
  idField.attr('data-pet-type',selectField.find('option[value="'+id+'"]').attr('data-pet-type'));
  })
  
$('input[name="id"]').on('change', function(){

  var id = $(this).val();
  var selectField = $(this).siblings('select');

  $(this).attr('data-max-weight',selectField.find('option[value="'+id+'"]').attr('data-max-weight'));
  $(this).attr('data-min-weight',selectField.find('option[value="'+id+'"]').attr('data-min-weight'));
  $(this).attr('data-pet-type',selectField.find('option[value="'+id+'"]').attr('data-pet-type'));
  
})
  
})

